import { Injector } from '@angular/core';
import { TicketGuideDialogService } from './ticket-guide-dialog.service';

export function ticketGuideDialogInitializer(injector:Injector) {
  return () => {
    const ticketGuideDialogService:TicketGuideDialogService = injector.get(TicketGuideDialogService);
    // start listen
    ticketGuideDialogService.activate();
  };
}